import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE, PRICE_BEFORE } from '../data/gymklar';
const recap = ['6 bind', '5 bonusser', '240 sider', '1.–9. klasse'];
const reassurances = ['Direkte download', 'PDF klar til print', '7 dages pengene-tilbage-garanti'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-101" data-mp="15c2d75si4hqb">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-102" data-mp="1jbaga9rsc9zs" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-103" data-mp="1ec7j1bi1r82d">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-104" data-mp="1t2ev99hgnuum">
          Dit engelskår kan være <em className="text-red-700" data-id="element-105" data-mp="1o67nrc9f2bak">klart allerede i dag.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-106" data-mp="223w90l7ebkg5">
          I stedet for at lede efter materialer, lave hver lektion selv og bruge søndag aften
          på forberedelse, har du et færdigt system til hele skoleåret. Mere tid til det, der
          virkelig betyder noget:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-107" data-mp="s6ij559k50jf">
          Dine elever. Dine timer. Dit liv uden for skolen.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-108" data-mp="124g6zrni8vbi">
          {recap.map(item => <li key={item} data-id="element-109" data-mp="1b3jsf2a59mt6">{item}</li>)}
        </ul>

        <p className="mt-8 text-base text-slate-900/60" data-id="element-110" data-mp="1b28ngz4yq90h">
          Før <s className="decoration-red-700 decoration-2" data-id="element-111" data-mp="1fujl1vc8dipv">{PRICE_BEFORE}</s>
        </p>
        <p className="mt-2 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-112" data-mp="1ktd19viwjntq">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-113" data-mp="1pszggaiaje56">Engangsbetaling – intet abonnement.</p>

        <div className="mt-8 flex justify-center" data-id="element-114" data-mp="1ttrpb2n93h0x">
          <CtaButton className="w-full sm:w-auto" data-id="element-115" data-mp="1tukrrrf6fkd9" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-116" data-mp="3qtvzej24veiv">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-117" data-mp="3lx5jpwu8qkxz">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-118" data-mp="3hux4zgqwtkf" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}